var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbbey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_108",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 108",
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.49,
    height: 20.859,
    viewBox: "0 0 115.49 20.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_16",
    "data-name": "\\u30D1\\u30B9 16",
    d: "M122.834,0h9.818c3.968,0,6.666,1.282,6.666,5.17a4.588,4.588,0,0,1-2.839,4.355,5.087,5.087,0,0,1,3.829,5.282c0,4.24-3.6,6.052-7.362,6.052H122.834Zm4.589,8.441h4.651c1.6,0,2.795-.728,2.795-2.479,0-1.991-1.513-2.395-3.154-2.395h-4.291Zm0,8.85h4.9c1.816,0,3.386-.581,3.386-2.747,0-2.132-1.338-2.981-3.3-2.981h-4.991Z",
    transform: "translate(-94.111 -0.001)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_17",
    "data-name": "\\u30D1\\u30B9 17",
    d: "M223.55,0h9.819c3.971,0,6.657,1.282,6.657,5.17a4.587,4.587,0,0,1-2.836,4.355,5.089,5.089,0,0,1,3.831,5.282c0,4.24-3.6,6.052-7.364,6.052H223.55Zm4.589,8.441h4.644c1.609,0,2.806-.728,2.806-2.479,0-1.991-1.523-2.395-3.15-2.395h-4.3Zm0,8.85h4.913c1.806,0,3.38-.581,3.38-2.747,0-2.132-1.344-2.981-3.3-2.981h-4.992Z",
    transform: "translate(-171.276 -0.001)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_18",
    "data-name": "\\u30D1\\u30B9 18",
    d: "M322.8,0h15.6V3.856H327.385V8.327h10.109v3.559H327.385V17h11.25v3.857H322.8Z",
    transform: "translate(-247.317 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_19",
    "data-name": "\\u30D1\\u30B9 19",
    d: "M416.005,12.738,408.324,0h5.168l4.879,8.233L423.218,0h5.115L420.6,12.851V20.86h-4.591Z",
    transform: "translate(-312.842 -0.001)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20",
    "data-name": "\\u30D1\\u30B9 20",
    d: "M9.294,0h5.2l9.292,20.859H18.9l-1.94-4.789H6.756L4.735,20.859H0Zm5.893,11.837-3.355-8.21-3.363,8.21Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbey);
export default __webpack_public_path__ + "static/media/abbey.422a3c89c9fb3af292313af0a2e0577d.svg";
export { ForwardRef as ReactComponent };